import { CtrlCollection, CtrlType } from "@yuigoto/ctrl";
import Bancos from "assets/data/bancos.json";
import { Col } from "components/grid/Col";
import { Container } from "components/grid/Container";
import { Row } from "components/grid/Row";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { ExtendedControl } from "core/controls/ExtendedControl";
import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { UiActions } from "state/actions/UiActions";
import { PartnerInfoActions } from "state/actions/user/PartnerInfoActions";
import Styles from "views/pages/DadosPessoais.module.scss";
import { GlampartnerDataControl } from "../../controls/GlampartnerDataControl";

class GlampartnerData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationMessage: "",
      bankList: {},
      accountTypes: {}
    };

    this.collection = new CtrlCollection();

    this.loadForm()

    //this.updateField  = this.updateField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  loadForm = () => {
    let infos = this.props.partner;
    if (infos === null) return;
    for (let i in GlampartnerDataControl) {
      if (Array.isArray(GlampartnerDataControl[i])) {
        let tempCollection = new CtrlCollection();
        for (let n in GlampartnerDataControl[i]) {

          let gpInfoValue = infos[GlampartnerDataControl[i][n].name];

          if(typeof gpInfoValue !== "boolean" ){
            gpInfoValue = (!gpInfoValue) ? gpInfoValue : infos[GlampartnerDataControl[i][n].name].toString();

            //adicionada essa transformação para sanar casos onde o valor pode assumir ZERO;
            gpInfoValue = gpInfoValue === 0 ? '0' : gpInfoValue;
          }

          GlampartnerDataControl[i][n].value = gpInfoValue;
          let ctrlOptions = {};

          if (GlampartnerDataControl[i][n].component) {
            ctrlOptions.component = GlampartnerDataControl[i][n].component;
          }

          tempCollection.add(new ExtendedControl(GlampartnerDataControl[i][n], ctrlOptions));

        }

        this.collection.collection.push(tempCollection);
      } else {
        let name = GlampartnerDataControl[i].name;
        let alias = GlampartnerDataControl[i].alias;
        GlampartnerDataControl[i].value = infos[alias] || infos[name];
        let ctrlOptions = {};
        if (GlampartnerDataControl[i].component) {
          ctrlOptions.component = GlampartnerDataControl[i].component;
        }

        this.collection.add(new ExtendedControl(GlampartnerDataControl[i], ctrlOptions));
      }
    }

    let issueCtrl = this.collection.get("issueInvoice");
    let cnpj = this.collection.get("cnpjHolder");
    let companyName = this.collection.get("companyName")
    let nickCompanyName = this.collection.get("nickCompanyName")

    companyName.type = (issueCtrl.value === true) ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    nickCompanyName.type = (issueCtrl.value === true) ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    cnpj.type = (issueCtrl.value === true) ? CtrlType.CNPJ : CtrlType.HIDDEN;
    console.log(this.collection)
    issueCtrl.onChange = (e,v) =>{
      cnpj.type = (issueCtrl.value === true) ? CtrlType.CNPJ : CtrlType.HIDDEN;
      companyName.type = (issueCtrl.value === true) ? CtrlType.DEFAULT : CtrlType.HIDDEN;
      nickCompanyName.type = (issueCtrl.value === true) ? CtrlType.DEFAULT : CtrlType.HIDDEN;

      cnpj.required = (issueCtrl.value === true) ? true : false;
      companyName.required = (issueCtrl.value === true) ? true : false;
      nickCompanyName.required = (issueCtrl.value === true) ? true : false;
      this.forceUpdate();
    }
  }

  convertedBankName = (infos) => {
    let bankCode = infos.bankCode;
    if (!bankCode) return null;
    let bankObj = Bancos.filter((bank) => {
      let normalizedBankCode = bank.value - 0;
      return normalizedBankCode == bankCode;
    });
    let completeBankName = `${bankObj[0].value} - ${bankObj[0].name}`;
    return completeBankName;
  }

  componentDidMount() {
    if (!this.props.partner) return;

    this.renderBanksList();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.partner && this.props.partner !== null) {
      this.loadForm();
      this.renderBanksList();

    }
  }

  renderBanksList = () => {
    let bancosTotais = {};

    for (let bank of Bancos) {
      bancosTotais[bank.value] = bank.name.trim();
    }

    this.setState(
      {
        bankList: bancosTotais
      },
      () => {

        let bankControl = this.collection.get("bankName"),
          opts = [];

        for (let bank of Bancos) {
          opts.push({
            name: `${bank.value} - ${bank.name.trim()}`,
            value: bank.name.trim()
          });
        }

        bankControl.options = opts;
        bankControl.onChange = (evt, value) => {
          let bankCodeControl = this.collection.get("bankCode");

          for (let bank of Bancos) {
            if (value.trim() === bank.name.trim()) {
              bankCodeControl.value = bank.value;
            }
          }

          this.forceUpdate();
        };

        this.forceUpdate();
      }
    );
  }

  onSubmit(event) {
    event.preventDefault();

    let isValid = this.collection.validate();
    if (!isValid) {
      this.forceUpdate();
      //this.props.errorAlert("Campos inválidos");
      return;
    }
    else {
      let partner = this.props.partner;
      this.props.loaderShow();

      this.props.partnerUpdate(
        Object.assign({},
          partner,
          this.collection.toObject(true),
          { access_token: this.props.token.access_token }
        ),
        (response) => {
          const {
            result,
            statusCode
          } = response;

          this.props.loaderHide();

          if (statusCode === 200) {
            this.props.successAlert(
              result && result.message
                ? result.message
                : "Atualizado com sucesso"
            );
          }
          else {
            this.props.errorAlert(
              result && result.message
                ? result.message
                : "Não foi possível atualizar seus dados"
            );
          }
        }
      );

    }
  }

  render() {
    if (!this.props.partner) return null;

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Portal Glampartners : Dados Para Pagamento</title>
        </Helmet>
        <h1>Dados Para Pagamento</h1>

        <Container fluid>
          <div className={"p-2 p-lg-5"} style={{ background: "#fff", marginBottom: 30 }}>
            *A emissão de nota fiscal é muito importante para influenciadoras que estão no início de carreira, uma vez que, para a maioria das empresas contratantes, é obrigatória a NF para o fechamento de campanhas e contratos. Além disso, pode demonstrar ainda mais profissionalismo na sua entrega!
          <div className={"mt-5"}>
             <a href="https://www.gov.br/empresas-e-negocios/pt-br/empreendedor/quero-ser-mei" target="blank">Clique aqui</a> para saber como se tornar MEI e passar a emitir notas fiscais.
          </div>
        </div>
          <Row>
            <Col xs={12} md={12}>
              <div className={"gb-contentblock p-4 level-2 mb-2"}>
                <form onSubmit={this.onSubmit}>
                    <p className="col-12 d-flex justify-content-end align-items-end">
                      <small>* Campo Obrigatório</small>
                    </p>
                    <p className={Styles['cnpjAlert']}>
                      <b>IMPORTANTE!</b> <br/>
                      Caso possua CNPJ e emita Nota Fiscal para recebimento de comissões a conta bancária cadastrada deverá ter titularidade Pessoa Juridica (CNPJ).
                    </p>
                  {ControlRenderer.renderCollection(this.collection)}
                  <div className={Styles['info__buttons']}>
                    <button className={"btn btn-light-pink btn-md"}>
                      Alterar Dados
                  </button>
                  </div>
                </form>
              </div>
            </Col>

          </Row>
        </Container>
      </div>

    );
  }

}
const mapStateToProps = (state) => ({
  store: state,
  partner: state.partnerInfo.data,
  token: state.token.data

});

const mapDispatchToProps = (dispatch) => {
  return {
    partnerUpdate: (partner, callback) => {
      dispatch(PartnerInfoActions.savePartnerData(partner, callback))
    },
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow())
    },
    loaderHide: () => {
      dispatch(UiActions.loaderHide())
    }
  }
}
GlampartnerData = connect(mapStateToProps, mapDispatchToProps)(GlampartnerData);

export { GlampartnerData };
